// extracted by mini-css-extract-plugin
export default {"switcher":"LanguageSwitcher_switcher__Rb8m2","flag":"LanguageSwitcher_flag__4i2L-"};